module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/power-planner/power-planner/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main